<template>
  <div class="registration-complete white-area">
    <section class="white-area with-gift-card-session-container">
      <img
        v-lazy="loginImage"
        class="registration-complete__image"
        alt="新規登録完了"
      />
      <h1 class="registration-complete__header headline">
        giftee へようこそ
      </h1>
      <div class="registration-complete__content">
        <p class="body">
          本登録が完了しました！
        </p>
        <p v-show="enableSubMessage" class="body">
          {{ subMessage }}
        </p>
        <p v-show="enableDescriptionMessage" class="body">
          {{ descriptionMessage }}
        </p>
      </div>
      <div class="button-area">
        <ButtonPrimary
          :text="primaryButtonText"
          class="registration-complete__primary-button"
          @click-button="onClickPrimaryButton"
        />
      </div>
    </section>
  </div>
</template>

<script>
import loginImage from '../../../../../../src/images/image_login.svg'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary'

export default {
  name: 'RegistrationComplete',
  components: { ButtonPrimary },
  props: {
    subMessage: {
      type: String,
      required: false,
      default: ''
    },
    descriptionMessage: {
      type: String,
      required: false,
      default: ''
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    primaryButtonLink: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loginImage: ''
    }
  },
  computed: {
    enableSubMessage() {
      return this.subMessage.length !== 0
    },
    enableDescriptionMessage() {
      return this.descriptionMessage.length !== 0
    }
  },
  created() {
    this.loginImage = loginImage
  },
  methods: {
    onClickPrimaryButton() {
      location.href = this.primaryButtonLink
    }
  }
}
</script>

<style lang="scss" scoped>
.registration-complete {
  min-height: calc(100vh - 110px);

  &__image {
    margin-top: 0;
    margin-bottom: 16px;
    max-width: 100%;
  }

  &__header {
    margin-bottom: 16px;
  }

  &__message {
    margin-bottom: 16px;
  }

  &__content {
    margin-top: 0;
    margin-bottom: 0;
    font-family: Arial;
    line-height: 1.6;
  }

  &__primary-button {
    display: inline-block;
  }
}
</style>
